import { render } from "./HeaderItem.vue?vue&type=template&id=8e7508d2&scoped=true"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"

import "./HeaderItem.vue?vue&type=style&index=0&id=8e7508d2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7508d2"]])

export default __exports__